import assign from '../assign/index.js';
export default function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/date-fns/esm/_lib/cloneObject/index.js
// module id = 381
// module chunks = 6